import { render, staticRenderFns } from "./navbarSas.vue?vue&type=template&id=3db0b765&scoped=true"
import script from "./navbarSas.vue?vue&type=script&lang=js"
export * from "./navbarSas.vue?vue&type=script&lang=js"
import style0 from "./navbarSas.vue?vue&type=style&index=0&id=3db0b765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db0b765",
  null
  
)

export default component.exports